import { AIImproveWritingPromptName } from 'apis/ai';

import expand from './assets/expand.png';
import makeFormal from './assets/make_formal.png';
import makeFriendly from './assets/make_friendly.png';
import matchStyleGuide from './assets/match_style_guide.png';
import matchTone from './assets/match_tone.png';
import shorten from './assets/shorten.png';

export type Improvement<TValue> = {
  name: string;
  icon: string;
  value: TValue;
  includeContext: boolean;
};

export const builtInImprovements: readonly Improvement<AIImproveWritingPromptName>[] =
  [
    {
      name: 'Apply writing style guide',
      icon: matchStyleGuide,
      value: 'repeat-input',
      includeContext: true,
    },
    {
      name: 'Expand',
      icon: expand,
      value: 'expand_reply',
      includeContext: true,
    },
    {
      name: 'Shorten',
      icon: shorten,
      value: 'make_concise',
      includeContext: false,
    },
    {
      name: 'Match tone',
      icon: matchTone,
      value: 'match_tone',
      includeContext: false,
    },
    {
      name: 'Make formal',
      icon: makeFormal,
      value: 'make_formal',
      includeContext: false,
    },
    {
      name: 'Make friendly',
      icon: makeFriendly,
      value: 'make_friendly',
      includeContext: false,
    },
  ] as const;
